export default __webpack_public_path__ + "static/media/Hospital-A.e9df1c0d.svg";